export default '/build/35bc7735.svg'